/**
 * @author xyguo
 * @description 远程评估详情页面配置
 * @Date  2021/7/19
 */
import React from 'react'
import { component_tool, framework_tool,utils_tool } from '@/tool';
import { WizTableForm } from '../../../common'
import moment from "moment";
//import AuthVideo from './authVideo';
import AuthVideo from './../../class/classStudent/classStudentRemoteAuth/authVideo';
import BatchInput from "./../../class/classStudent/classStudentRemoteAuth/batchInput";
import { WizNotice } from 'wiz-components';
import HighSet from "@/containers/common/highSet";
let { $$, checkStrLength } = utils_tool;
const personInfoConfig = WizTableForm.Config.user(this, { apiParams: { state: 1,positionIdList: ["110"] },path:'personManage/getTeachelist' })
const userConfig = WizTableForm.Config.user(this, { apiParams: { status: 1,roleConfig: "teacherRole" } });

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

let { WizModal, WizTimePicker } = component_tool;
const { RangePicker } = WizTimePicker;
let ref_;



//配置项
let componentName = 'orgRemoteAuthDetail'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: '检核时间',
    name: 'openTime',
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  },
  {
    title: "检核场次",
    name: "name",
    searchItem: {
    },
    tableItem: { width: 200 },
  },
  {
    title: "检核项目",
    name: "remoteAuthName",
    searchItem: {
    },
    tableItem: { width: 180 },
  },
  {
    title: "经销商简称",
    name: "shortName",
    searchItem: {},
    tableItem: { width: 150 },
  },
  {
    title: "经销商代码",
    name: "dealerNumber",
    searchItem: {},
    tableItem: {width: 180},
  },
  {
    title: '检核时间',
    name: 'startToEndDateStr',
    tableItem: {
      width: 380,
    },
  },
  {
    title: "检核终端",
    name: "authWay",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: '培训助手' },
      { code: 1, codeName: '企业微信' },
    ],
    tableItem: {
      width: 80,
    },
  },
  {
    title: "检核状态",
    name: "authState",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: '未开始' },
      { code: 2, codeName: '检核中' },
      { code: 3, codeName: '未参考' },
      { code: 4, codeName: '已完成' },
      { code: 6, codeName: '已作废' },

    ],
    tableItem: {
      width: 80,
    },
  },
  {
    title: "讲师",
    name: "lectureIds",
    searchItem: {
      type: 'diy',
      diy: WizTableForm,
      ...userConfig,
      //selectType: 'radio',
      onSubmit:(obj)=>{
        return obj.value
      }
    },
  },
  {
    title: "讲师",
    name: "lectureName",
    tableItem: {
      width: 80,
    },
  },
  {
    title: "总得分",
    name: "score",
    tableItem: {
      width: 60,
      render: (text, record) => {
        return  record && record.authState==4 && (text || text===0 )&& text>=0 ? text : ""
      }
    },
  },
  {
    title: "通过状态",
    name: "pass",
    dict: [
      { code: 0, codeName: '未通过' },
      { code: 1, codeName: '通过' }
    ],
    searchItem: {
      type: 'select'
    }, 
    tableItem: {
    },
  },
];


const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      //btnAccessCheck: false,
      searchBarProps: {
        dataFormat: (v) => {
          let value = Object.assign([], v)
          if (value['openTime'] && value['openTime'].length === 2) {
            value['startDate'] = moment(value['openTime'][0]).format("YYYY-MM-DD");
            value['endDate'] = moment(value['openTime'][1]).format("YYYY-MM-DD");
          }else{
            value['startDate'] = undefined;
            value['endDate'] = undefined;
          }
          // delete value['openTime']
          return value
        },
        buttonSort: ['add','importGrades','export'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: {icon: 'plus', children: '新增', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationDetailAdd'
              }
            }
          },
          {
            key: 'importGrades',
            custom: true,
            params: { icon: 'import', children: '导入成绩', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationScoreImport'
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: {  icon: 'export', children: '导出'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: ['look','update','videoPlayback', 'modifyScore','download','participationStatisticsManagement','advancedSet','disable'],
      rowOperateView: [
        {
          key: "look",
          custom: true,
          params: { children: "查看" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationDetailInfo"
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationDetailUpd"
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: false };
            if (record.record && record.record.authState > 0) {
              result.disabled = true
            }
            return result
          },
        },
        {
          key: "videoPlayback",
          custom: true,
          params: { children: "录像回放"},
          customOnClick: {
            key: "modal",
            params: {
              modalKey: "playbackModal",
              modalParams: {
                title: "录像回放",
                diy: (e) => {
                  e.record = Object.assign({}, e.record);
                  return (
                    <AuthVideo
                      key={'authVideo-'+e.record.id}
                      {...e}
                      type={0}
                      ref={r => {
                        ref_ = r && r.getWrappedInstance();
                      }}
                    />
                  )
                },
                footer:null,

                width: 700
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.authState === 4) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "modifyScore",
          custom: true,
          params: { children: "修改分数" },
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationScore'
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.authState === 4) {
              result.disabled = false
            }
            return result
          },
        },

        {
          key: "download",
          custom: true,
          params: { children: "视频下载"},
          customOnClick: {
            key: "modal",
            params: {
              modalKey: "downloadModal",
              modalParams: {
                title: "视频下载",
                diy: (e) => {
                  e.record = Object.assign({}, e.record);
                  return (
                    <AuthVideo
                      key={'authVideo-'+e.record.id}
                      {...e}
                      type={1}
                      ref={r => {
                        ref_ = r && r.getWrappedInstance();
                      }}
                    />
                  )
                },
                footer:null,

                width: 700
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.publishState > 0 && record.record.publishState!=3) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "participationStatisticsManagement",
          custom: true,
          params: { children: "参训统计管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationInteractLiveList" 
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: false };
            if (record.record && record.record.authState == 6) {
              result.disabled = true
            }
            return result
          },
        },
        {
          key: 'advancedSet',
          custom: true,
          params: {children: '高级设置'},
          customOnClick: {
            key: 'modal',
            params: {
              modalParams: {
                title: '高级设置',
                bordered: true,
                footer: null,
                destroyOnClose: true,
                diy: (e) => {
                  return <>
                    <HighSet data={{record: e.record,bizType: 47}}
                             changeModal={e.changeModal}
                    />
                  </>
                },
                width: 950
              },
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: false };
            if (record.record && record.record.authState > 0) {
              result.disabled = true
            }
            return result
          },
        },
        {
          key: "disable",
          custom: true,
          params: { children: "作废"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateAuthState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `你是否确认将“经销山名称:${record.shortName}的检核场次:${record.name}”作废？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    authState: 6,
                    id: record['id'],
                    remoteAuthId : record['remoteAuthId']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          },
          recordChangeParams: (record, rows) => {
            let result = {disabled: true};
            if (record.record &&  record.record.authState === 0) {
              result.disabled = false
            }
            return result
          },
        },
      ]
    }
  }
};

let reduxTemplateCofig = (args) => {
  let {remoteAuthId }= args;
  const apis = {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {remoteAuthId : remoteAuthId ? remoteAuthId : null , type:1}
      }
    },
    publishState: {
      path: `${componentName}/publishStateRe`,
      payload: {
        key: `${componentName}@publishState`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {remoteAuthId : remoteAuthId ? remoteAuthId : null , type:1}
      }
    },
    updateAuthState: {
      path: `remoteAssessment/updateAssessmentState`,
      payload: {
        key: `remoteAssessment@updateAssessmentState`,
        apiParams: {}
      }
    },
  }
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
